import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client.js';
import type { MujNalez } from '../api/types.js';

/**
 * Moje nálezy mistra (GET /api/nalezy/moje) + notifikační tečka „přibyl
 * zamítnutý nález". Viděná zamítnutí se pamatují lokálně (localStorage) —
 * tečka svítí, dokud mistr neotevře Moje nálezy. Žádné částky (zeď drží API).
 */

const KLIC_VIDENE = 'helfr.teren.videneZamitnuteNalezy';
const UDALOST = 'helfr:videneZamitnuteNalezy';

export function ctiVideneZamitnute(): Set<string> {
  try {
    const raw = localStorage.getItem(KLIC_VIDENE);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

/** Označí zamítnuté nálezy jako viděné (otevření Moje nálezy) — tečka zhasne. */
export function oznacZamitnuteVidene(ids: string[]): void {
  try {
    const videne = ctiVideneZamitnute();
    for (const id of ids) videne.add(id);
    localStorage.setItem(KLIC_VIDENE, JSON.stringify([...videne]));
  } catch {
    // private mode apod. — tečka je bonus, ne podmínka
  }
  window.dispatchEvent(new Event(UDALOST));
}

/** Moje nálezy + počet NOVÝCH zamítnutých (dosud neviděných) pro tečku v Menu. */
export function useMojeNalezy(enabled: boolean): {
  nalezy: MujNalez[] | undefined;
  nacitani: boolean;
  noveZamitnute: number;
} {
  const [, setTik] = useState(0);
  useEffect(() => {
    const obnov = () => setTik((t) => t + 1);
    window.addEventListener(UDALOST, obnov);
    return () => window.removeEventListener(UDALOST, obnov);
  }, []);

  const { data: nalezy, isLoading } = useQuery({
    queryKey: ['moje-nalezy'],
    queryFn: () => api.get<MujNalez[]>('/api/nalezy/moje'),
    enabled,
    staleTime: 60 * 1000,
  });

  const videne = ctiVideneZamitnute();
  const noveZamitnute = (nalezy ?? []).filter(
    (n) => n.stav === 'zamitnut' && !videne.has(n.id),
  ).length;

  return { nalezy, nacitani: isLoading, noveZamitnute };
}
